export const TOOL_TASK = 'add-to-account-team';
export const TOOL_TITLE = 'Add To Account Team';
export const TOOL_PROGRESS_LABEL = 'Bulk adding to account team progress...';
export const TOOL_STACK_OVERFLOW_MESSAGE = 'Please try again once adding user to account team finishes';
export const FILE_NAME = 'Add-to-account-team-report';
export const FILE_HEADERS = {
    accountName: 'Account Name',
    managerEmail: 'Target Team Member Email',
    newRole: 'Account Team Role',
    primary: 'Primary',
    receiveAlert: 'Receive Account Alerts',
    actionStatus: 'Action Status',
    affectedRelations: 'Affected Team Members',
};
